const authorisationTypeMap = {
  'LICBODY': 'Licensed body',
  'NOTSRA-F': 'Other organisations not regulated by SRA but may have regulated solicitors working there',
  'RECBODY': 'Recognised body',
  'RECSOLE': 'Recognised sole practice'
};

const authorisationStatusMap = {
  'CEASE': 'Authorised but ceased trading',
  'CONDITION': 'Authorised with conditions',
  'INTERVENE': 'Intervened firm (closed down by the SRA)',
  'YES': 'Authorised'
};

const organisationTypeMap = {
  'FIRMOTHER': 'Regulated by another Regulator',
  'FIRMSRA': 'SRA Regulated Firm',
  'ORG': 'Other Organisation not regulated by SRA but may have regulated Solicitors working there'
};

export const getReadableAuthorisationType = (type) => {
  return authorisationTypeMap[type] || type;
};

export const getReadableAuthorisationStatus = (status) => {
  return authorisationStatusMap[status] || status;
};

export const getReadableOrganisationType = (type) => {
  return organisationTypeMap[type] || type;
}; 